import Backbone from "backbone";
import $ from "jquery";

// LoginToggle
export default Backbone.View.extend({

    events: {
      'click .js-toggle-signUp': 'toggleSignUp',
    },

    initialize: function () {
      this.isActive = false;

      // Hack to avoid toggle form when email already exist
      if ($(".field-validation-error").length > 0) {
        this.toggleSignUp();
      }

    },

    toggleSignUp: function (e) {
      this.render(e);
    },

    render: function (e) {
      if (this.isActive) {
        $(".js-login-toggleContent").removeClass("isActive");
        $(".js-toggle-signUp").toggleClass("isHidden");
        this.isActive = false;
      } else {
        $(".js-login-toggleContent").addClass("isActive");
        $(".js-toggle-signUp").toggleClass("isHidden");
        this.isActive = true;
      }
    }

  });
